import React, { useEffect, useMemo, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import Box from '@mui/material/Box';
import ConfirmDeleteDialog from './Modal/ConfirmDelete';
import QueryColumnSelection from './Modal/Queries/QueryColumnSelection';
import { Button } from '@mui/material';
import QueryEditMenuButton from './Queries/QueryEditMenuButton';
import TaskQueryApiService from '../api/TaskQueryApiService';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from './Common/SnackbarProvider';

const Queries = () => {
    const snackbar = useSnackbar();
    const { t } = useTranslation();
    const [queries, setQueries] = useState([]);
    const [loading, setLoading] = useState(true);

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showEditDialog, setShowEditDialog] = useState(false);
    const [currentSelectedQuery, setCurrentSelectedQuery] = useState(0);
    const [componentKey, setComponentKey] = useState(0);

    const taskQueryApiService = new TaskQueryApiService();

    const columns = useMemo(() => [
        { field: 'queryId', headerName: t('common.id'), width: 90, editable: true },
        { field: 'queryName', headerName: t('fieldName.name'), minWidth: 90, flex: 1 },
        { field: 'taskQueryDescription', headerName: t('fieldName.description'), minWidth: 150, flex: 3 },
        {
            field: 'edit',
            headerName: t('common.edit'),
            sortable: false,
            minWidth: 40,
            renderCell: (params) => {
                return <QueryEditMenuButton params={params}
                    setCurrentSelectedQuery={setCurrentSelectedQuery}
                    setShowEditDialog={setShowEditDialog}
                    setShowDeleteDialog={setShowDeleteDialog}
                />;
            },
        },
    ], [t]);

    async function onDeleteClick (value) {
        if (value) {
            const deletedQuery = await taskQueryApiService.deleteTaskQuery(currentSelectedQuery);
            if(deletedQuery && deletedQuery.success) {
                snackbar.success(t('queriesPage.toast.deleted'));
            } else if(deletedQuery && deletedQuery.message) {
                snackbar.error(t('queriesPage.toast.deleteError', { error: deletedQuery.message }));
            } else {
                snackbar.success(t('queriesPage.toast.deleteError', { error: deletedQuery }));
            }
            const componentKeyAdd = componentKey + 1;
            setComponentKey(componentKeyAdd);
            setShowDeleteDialog(false);
        } else {
            setShowDeleteDialog(false);
        }
    }

    async function populateQueries () {
        const data = await taskQueryApiService.getAllQueries();
        setQueries(data.data);
        setLoading(false);
    }

    useEffect(() => {
        if (!showEditDialog) {
            populateQueries();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [componentKey, showEditDialog]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - var(--ct-header-h, 56px))' }}>
            <h1>{t('queriesPage.title')}</h1>
            <br/>
            <Button
                variant={'contained'}
                onClick={() => {
                    setCurrentSelectedQuery(0);
                    setShowEditDialog(true);
                }}>{t('queriesPage.createButton')}</Button>
            <Box sx={{ flex: 1, minHeight: 0, width: '100%' }}>
                <DataGridPro
                    rows={queries}
                    columns={columns}
                    pageSize={25}
                    loading={loading}
                    getRowId={(row) => row.queryId}
                />
            </Box>

            <ConfirmDeleteDialog
                id="confirm-delete"
                keepMounted
                value={currentSelectedQuery}
                open={showDeleteDialog}
                onClose={onDeleteClick}
            />

            <QueryColumnSelection
                open={showEditDialog}
                setIsOpen={setShowEditDialog}
                queryId={currentSelectedQuery}
            />
        </Box>
    );
};
export default Queries;
